<div class="sm:hidden mx:block" *ngIf="showPlaceTips">
  <div
    class="bg-error text-base min-h-[48px] flex-v-center mb-2 justify-between"
    *ngIf="placeErrorMessage.length > 0"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div *ngFor="let error of placeErrorMessage">
          {{ error.severity == "E" ? error.message : "" }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showPlaceTips = false"
    ></svg-icon>
  </div>
</div>
<div class="sm:hidden mx:block" *ngIf="showTips">
  <div
    class="bg-error text-base min-h-[48px] flex-v-center mb-2 justify-between"
    *ngIf="hasErrorMessage || errorMessage.length > 0"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div *ngIf="hasErrorMessage">{{ "CART_ERROR_TIPS" | translate }}</div>
        <div *ngFor="let error of errorMessage">
          {{ error.severity == "E" ? error.message : "" }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2"
    *ngIf="messages.length > 0"
  >
    <div class="flex items-center">
      <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
      <div>
        <div *ngFor="let message of messages">{{ message.message }}</div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2"
    *ngIf="isRequiredDateShouldBeLater"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        {{ "REQUIRED_DATE_SHOULD_BE_LATER" | translate }}
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-success text-base h-[48px] flex-v-center justify-between mb-2"
    *ngIf="needSimulate"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        {{ "CART_SIMULATE_TIPS" | translate }}
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-success text-base h-[48px] flex-v-center justify-between mb-2"
    *ngIf="placeOrderEnable"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div>
          {{ "CART_PLACE_ORDER_TIPS" | translate }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
</div>
<nz-table
  class="cart-table"
  [nzData]="productList"
  #fixedTable
  [nzFrontPagination]="false"
  [nzScroll]="{ x: 'max-content' }"
>
  <thead>
    <tr>
      <th nzWidth="90">{{ "ITEM_NO" | translate }}</th>
      <th nzWidth="100">{{ "STATUS" | translate }}</th>
      <th nzWidth="220">{{ "ENTERED_MATERIAL_NO" | translate }}</th>
      <th nzWidth="180" class="!text-center">{{ "QUANTITY" | translate }}</th>
      <!-- <th *ngIf="country!=='/oes'"> {{'MOQ' | translate}}</th> -->
      <th nzWidth="180">{{ "ADD_DATE" | translate }}</th>
      <th nzWidth="200">{{ "DEPARTURE_PLAN" | translate }}</th>
      <th nzWidth="140">{{ "CART_TOTAL_VALUE" | translate }}</th>
      <th nzWidth="140">{{ "NET_PRICE" | translate }}</th>
      <th nzWidth="100" nzRight>{{ "ACTION" | translate }}</th>
    </tr>
  </thead>
  <tbody class="text">
    <ng-container *ngFor="let data of fixedTable.data">
      <tr *ngIf="getPromptMessages(data).length > 0">
        <td [attr.colspan]="9" class="!p-0">
          <div class="text-base flex items-center bg-warning h-[40px] p-2">
            <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-2"></svg-icon>
            <div>
              <div *ngFor="let msg of getPromptMessages(data)">
                {{ msg }}
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr
        *ngIf="
          data.isSimulated &&
          getMessageByPromotion(data.errorMessages).length > 0
        "
      >
        <td [attr.colspan]="9" class="!p-0">
          <div class="text-base flex items-center bg-warning h-[40px] p-2">
            <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-2"></svg-icon>
            <div>
              <div
                *ngFor="let msg of getMessageByPromotion(data.errorMessages)"
              >
                {{ msg }}
              </div>
            </div>
          </div>
        </td>
      </tr>
      <!-- checkError(data.errorMessages) && data.isSimulated-->
      <tr
        [ngClass]="{
          'not-orderable':
            data.errorTypes.includes('error') ||
            data.errorTypes.includes('stock_error'),
          'show-line':
            (data.isSimulated &&
              getMessagesExcludingPromotion(data.errorMessages).length == 0 &&
              data.components.length == 0) ||
            (!data.isSimulated &&
              getMessagesExcludingPromotion(data.errorMessages).length == 0)
        }"
      >
        <td>
          <div class="flex items-center">
            <svg-icon
              (click)="toggleSelect(data)"
              [iconName]="'new/choosed.svg'"
              *ngIf="data.isSelect"
            ></svg-icon>
            <svg-icon
              (click)="toggleSelect(data)"
              [iconName]="'new/checkbox.svg'"
              *ngIf="!data.isSelect"
            ></svg-icon>
            <span class="ml-1 font-bold">{{ data.itemNo }}</span>
          </div>
        </td>
        <td>
          <div class="flex-v-center">
            <p
              class="flex-v-center"
              *ngIf="
                getMessagesByType(data.errorMessages, 'E').length == 0 &&
                data.isSimulated
              "
            >
              <svg-icon
                [iconName]="'new/orderable.svg'"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="statusTemplate"
              ></svg-icon>
            </p>
            <p
              class="flex-v-center"
              *ngIf="getMessagesByType(data.errorMessages, 'E').length > 0"
            >
              <svg-icon
                [iconName]="'new/not_orderable.svg'"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="statusTemplate"
              ></svg-icon>
            </p>
            <p
              class="simulate-wait flex-v-center"
              *ngIf="
                !data.isSimulated &&
                getMessagesByType(data.errorMessages, 'E').length == 0
              "
            >
              <svg-icon
                [iconName]="'new/wait_simulate.svg'"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="statusTemplate"
              ></svg-icon>
            </p>
            <svg-icon
              [iconName]="'new/notification.svg'"
              class="ml-2"
              *ngIf="data.errorMessages.length > 0 || getPromptMessages(data).length > 0"
              nz-popover
              [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="msgTemplate"
            ></svg-icon>
          </div>
        </td>
        <td nzBreakWord>
          <div
            class="font-bold"
            [ngClass]="{
              'no-line-fixed':
                !data.errorTypes.includes('error') &&
                !data.errorTypes.includes('stock_error'),
              'not-orderable-fixed':
                data.errorTypes.includes('error') ||
                data.errorTypes.includes('stock_error'),
              'fixed-left': !(
                data.errorTypes.includes('error') ||
                data.errorTypes.includes('stock_error')
              )
            }"
          >
            <span>{{ data.inputMaterialNumber || "--" }}</span>
            <span class="non-bosch-tag" *ngIf="isOesCountry() && data.isNonBoschPartNo === 1">{{ "NON_BOSCH_PART_NO" | translate }}</span>
          </div>
          <div
            class="flex items-center h-[24px] w-[150px] text-base bg-promotion text-green"
            *ngIf="isInPromotion(data)"
          >
            <svg-icon [iconName]="'new/promotions.svg'" class="mx-2"></svg-icon>
            <span class="text-base">{{ "IN_PROMOTION" | translate }}</span>
          </div>
          <div
            class="color-green"
            *ngIf="data.errorTypes.includes('product_warning')"
            nz-popover
            [nzPopoverPlacement]="'top'"
            [nzPopoverContent]="productTemplate"
          >
            {{ data.materialNumber || "--" }}
          </div>
          <div *ngIf="!data.errorTypes.includes('product_warning')">
            {{ data.materialNumber || "--" }}
          </div>
          <div *ngIf="data.productName">
            {{ data.productName }}
            <svg-icon
              [iconName]="'new/arrow.svg'"
              nz-popover
              [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="infoTemplate"
              [size]="10"
              *ngIf="data.productName"
            ></svg-icon>
          </div>
        </td>
        <td>
          <div class="w-[180px]">
            <quantity-input
              mode="table"
              [inputQuantity]="data.inputQuantity"
              [(quantity)]="data.quantity"
              [moq]="data.minimumOrderQuantity"
              [errorTypes]="data.errorTypes"
              (quantityBlur)="quantityBlur($event, data)"
              (quantityChange)="quantityChange($event, data)"
            ></quantity-input>
          </div>
        </td>
        <!-- <td *ngIf="country !== '/oes'">
          <div class="text-center">
            {{ data.minimumOrderQuantity || "--" }}
          </div>
        </td> -->
        <td
          [ngClass]="{ 'error-date': data.errorTypes.includes('date_error') }"
        >
          <nz-date-picker
            (ngModelChange)="onDatePickerChange($event, data)"
            [nzDisabled]="data.errorTypes.includes('invalid_error')"
            [nzSuffixIcon]="suffixDate"
            [nzAllowClear]="false"
            [nzPlaceHolder]="'DELIVERY_DATE' | translate"
            nzFormat="yyyy-MM-dd"
            [ngModel]="data.expectedDate"
            [nzDisabledDate]="disabledDate"
          ></nz-date-picker>
          <ng-template #suffixDate>
            <svg-icon
              [iconName]="
                data.errorTypes.includes('invalid_error')
                  ? 'new/calendar-grey.svg'
                  : 'new/calendar.svg'
              "
              [size]="20"
            ></svg-icon>
          </ng-template>
        </td>
        <td>
          <!-- <div
            class="inventory"
            *ngIf="
              data.stockQuantity !== '' &&
              !data.isSimulated &&
              country !== '/oes'
            "
          >
            <svg-icon
              nz-popover
              [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="stockTemplate"
              [iconName]="
                data.stockQuantity === 0
                  ? 'new/red.svg'
                  : data.quantity <= data.stockQuantity
                  ? 'new/green.svg'
                  : 'new/yellow.svg'
              "
              [size]="20"
            ></svg-icon>
          </div> -->
          <div *ngIf="data.isSimulated">
            <p
              *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(data.simulateDeliveryInfoList)"
              [ngClass]="{
                'color-warning': deliveryInfo.deliveryDate > data.expectedDate,
                'color-green': deliveryInfo.deliveryDate <= data.expectedDate
              }"
            >
              <span>{{ deliveryInfo.deliveryDate }}</span>
            </p>
          </div>
        </td>
        <td>
          <div class="flex-v-center">
            <span class="net_value">{{
              data.totalAmount !== ""
                ? data.totalAmount.currency +
                  " " +
                  (data.totalAmount.value | number : "1.2-2")
                : "--"
            }}</span>
          </div>
        </td>
        <td>
          {{
            data.netPrice !== ""
              ? data.netPrice.currency +
                " " +
                (data.netPrice.value | number : "1.2-2")
              : "--"
          }}
        </td>
        <!-- Operation column -->
        <td class="fixed" nzRight [attr.rowspan]="getRowSpan(data)">
          <svg-icon
            [iconName]="'new/wishlist.svg'"
            [title]="'SAVE_FOR_LATER' | translate"
            *ngIf="
              getMessagesByType(data.errorMessages, 'E').length == 0 &&
              !data.errorTypes.includes('invalid_error')
            "
            class="mr-2 cursor-pointer"
            (click)="moveToWhishList(data)"
          ></svg-icon>
          <svg-icon
            [iconName]="'new/delete.svg'"
            [title]="'DELETE' | translate"
            (click)="removeFromCart(data.id)"
            class="cursor-pointer"
          ></svg-icon>
        </td>
      </tr>
      <ng-container *ngIf="data.isSimulated && data.components.length > 0">
        <tr
          *ngFor="let promotion of data.components; let j = index"
          [ngClass]="{
            'not-orderable':
              data.errorTypes.includes('error') ||
              data.errorTypes.includes('stock_error'),
            'show-line':
              getMessagesExcludingPromotion(data.errorMessages).length == 0
          }"
        >
          <td>
            <div class="font-bold">
              {{ promotion.itemNo }}
            </div>
          </td>
          <td>
            <div class="flex-v-center">
              <p
                class="flex-v-center"
                *ngIf="
                  getMessagesByType(data.errorMessages, 'E').length == 0 &&
                  data.isSimulated
                "
              >
                <svg-icon
                  [iconName]="'new/orderable.svg'"
                  nz-popover
                  [nzPopoverPlacement]="'top'"
                  [nzPopoverContent]="statusTemplate"
                ></svg-icon>
              </p>
              <p
                class="flex-v-center"
                *ngIf="getMessagesByType(data.errorMessages, 'E').length > 0"
              >
                <svg-icon
                  [iconName]="'new/not_orderable.svg'"
                  nz-popover
                  [nzPopoverPlacement]="'top'"
                  [nzPopoverContent]="statusTemplate"
                ></svg-icon>
              </p>
              <p
                class="simulate-wait flex-v-center"
                *ngIf="
                  !data.isSimulated &&
                  getMessagesByType(data.errorMessages, 'E').length == 0
                "
              >
                <svg-icon
                  [iconName]="'new/wait_simulate.svg'"
                  nz-popover
                  [nzPopoverPlacement]="'top'"
                  [nzPopoverContent]="statusTemplate"
                ></svg-icon>
              </p>
              <svg-icon
                [iconName]="'new/notification.svg'"
                class="ml-2"
                *ngIf="data.errorMessages.length > 0"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="msgTemplate"
              ></svg-icon>
            </div>
          </td>
          <td nzBreakWord>
            <div class="font-bold">
              {{ promotion.materialNumber || "--" }}
            </div>
            <div
              *ngIf="promotion.isGift && data.isSimulated"
              class="flex items-center h-[24px] w-[116px] text-base bg-purpleBg text-purple"
            >
              <svg-icon [iconName]="'new/gift.svg'" class="mx-2"></svg-icon>
              <span class="text-base">{{ "GIVEAWAY" | translate }}</span>
            </div>
            <div
              class="color-green"
              *ngIf="data.errorTypes.includes('product_warning')"
              nz-popover
              [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="productTemplate"
            >
              {{ promotion.materialNumber || "--" }}
            </div>
            <div *ngIf="!data.errorTypes.includes('product_warning')">
              {{ promotion.materialNumber || "--" }}
            </div>
            <div *ngIf="promotion.productName">
              {{ promotion.productName }}
              <svg-icon
                [iconName]="'new/arrow.svg'"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="promotionInfoTemplate"
                [size]="10"
                *ngIf="promotion.productName"
              ></svg-icon>
            </div>
          </td>
          <td>
            <div class="text-center text-greyDisable">
              {{ promotion.quantity }}
            </div>
          </td>
          <td>
            <div class="text-center text-greyDisable">
              {{ promotion.minimumOrderQuantity || "" }}
            </div>
          </td>
          <td>
            <div class="text-greyDisable pl-[11px]">
              {{ data.expectedDate }}
            </div>
          </td>
          <td>
            <div
              class="inventory"
              *ngIf="!data.isSimulated && promotion.stockQuantity !== ''"
            >
              <svg-icon
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="promotionStockTemplate"
                [iconName]="
                  promotion.stockQuantity === 0
                    ? 'new/red.svg'
                    : promotion.quantity <= promotion.stockQuantity
                    ? 'new/green.svg'
                    : 'new/yellow.svg'
                "
                [size]="20"
              ></svg-icon>
            </div>
            <div *ngIf="promotion.isSimulated">
              <div
                *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(promotion.simulateDeliveryInfoList)"
                [ngClass]="{
                  'color-warning':
                    deliveryInfo.deliveryDate > data.expectedDate,
                  'color-green': deliveryInfo.deliveryDate <= data.expectedDate
                }"
              >
                <span>{{ deliveryInfo.deliveryDate }}</span
                ><span class="ml-2" *ngIf="shouldShowDeliveryQuantity()">{{ deliveryInfo.quantity }}</span>
              </div>
            </div>
            <ng-template #promotionStockTemplate>
              <div class="price-info">
                {{
                  promotion.stockQuantity === 0
                    ? ("NO_STOCK" | translate)
                    : promotion.quantity <= promotion.stockQuantity
                    ? ("IN_STOCK" | translate)
                    : ("LOW_STOCK" | translate)
                }}
              </div>
            </ng-template>
          </td>
          <td>
            <div class="flex-v-center text-greyDisable">
              <span class="net_value">{{
                promotion.totalAmount !== ""
                  ? promotion.totalAmount.currency +
                    " " +
                    (promotion.totalAmount.value | number : "1.2-2")
                  : "--"
              }}</span>
            </div>
          </td>
          <td class="text-greyDisable">
            {{
              promotion.netPrice !== ""
                ? promotion.netPrice.currency +
                  " " +
                  (promotion.netPrice.value | number : "1.2-2")
                : "--"
            }}
          </td>
          <ng-template #promotionInfoTemplate>
            <div class="price-info">
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "EAN" | translate }}:</span
                >
                <span class="color-grey7C font16-w500">{{
                  promotion.ean || "--"
                }}</span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "CART_VOLUME" | translate }}:</span
                >
                <span class="color-grey font16-w500"
                  >{{
                    promotion.shipmentDimension?.totalVolume
                      ? (promotion.shipmentDimension.totalVolume
                          | number : "1.2-2") +
                        promotion.shipmentDimension?.unitOfVolume
                      : "--"
                  }}
                </span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "CART_WEIGHT" | translate }}:</span
                >
                <span class="color-grey font16-w500">{{
                  promotion.shipmentDimension?.totalWeight
                    ? (promotion.shipmentDimension.totalWeight
                        | number : "1.2-2") +
                      promotion.shipmentDimension?.unitOfWeight
                    : "--"
                }}</span>
              </div>
            </div>
          </ng-template>
        </tr>
      </ng-container>

      <tr
        *ngIf="hasItemMessages(data)"
        class="error-desc"
        [ngClass]="{
          'not-orderable':
            data.errorTypes.includes('error') ||
            data.errorTypes.includes('stock_error')
        }"
      >
        <td [attr.colspan]="9">
          <ng-container>
            <p
              *ngFor="
                let error of getMessagesExcludingPromotion(data.errorMessages)
              "
              class="w100"
              [ngClass]="{
                'text-errorTips': error.severity == 'E',
                'text-yellow': error.severity == 'W'
              }"
            >
              <span class="flex-1">{{ error.message }}</span>
            </p>
            <p class="w100 text-yellow" *ngFor="let msg of getPromptMessages(data)">
              <span class="flex-1">{{ msg }}</span>
            </p>
          </ng-container>
        </td>
      </tr>
      <ng-template #deliveryDateTemplate>
        <div>
          <div
            class="flex"
            *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(data.simulateDeliveryInfoList)"
          >
            <span class="info-title font14-w500">{{
              deliveryInfo.deliveryDate
            }}</span>
            <span class="font14-w500" *ngIf="shouldShowDeliveryQuantity()">{{ deliveryInfo.quantity }}</span>
          </div>
        </div>
      </ng-template>
      <ng-template #statusTemplate>
        <div>
          <p
            class="simulate-success flex-v-center"
            *ngIf="
              getMessagesByType(data.errorMessages, 'E').length == 0 &&
              data.isSimulated
            "
          >
            <svg-icon [iconName]="'new/orderable.svg'" class="mr-2"></svg-icon
            >{{ "ORDERABLE" | translate }}
          </p>
          <p
            class="simulate-error flex-v-center"
            *ngIf="getMessagesByType(data.errorMessages, 'E').length > 0"
          >
            <svg-icon
              [iconName]="'new/not_orderable.svg'"
              class="mr-2"
            ></svg-icon
            >{{ "NOT_ORDERABLE" | translate }}
          </p>
          <p
            class="simulate-wait flex-v-center"
            *ngIf="
              !data.isSimulated &&
              getMessagesByType(data.errorMessages, 'E').length == 0
            "
          >
            <svg-icon
              [iconName]="'new/wait_simulate.svg'"
              class="mr-2"
            ></svg-icon
            >{{ "WAIT_SIMULATE" | translate }}
          </p>
        </div>
      </ng-template>
      <ng-template #moqTemplate>
        <div>
          <div class="flex">
            <span class="info-title font14-w500"> {{ "MOQ" | translate }}</span>
            <span class="font14-w500">{{
              data.minimumOrderQuantity || "--"
            }}</span>
          </div>
        </div>
      </ng-template>
      <ng-template #discountTemplate>
        <div class="msg_tips">
          <ng-container
            *ngIf="
              getMessagesByType(
                data.errorMessages,
                'E',
                'discount_warning'
              ) as messages
            "
          >
            <div class="flex" *ngFor="let msg of messages">
              <i class="tip_item"></i>
              <p>{{ msg }}</p>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template #productTemplate>
        <div class="msg_tips">
          <ng-container
            *ngIf="
              getMessagesByType(
                data.errorMessages,
                'E',
                'product_warning'
              ) as messages
            "
          >
            <div class="flex" *ngFor="let msg of messages">
              <i class="tip_item"></i>
              <p>{{ msg }}</p>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template #qtyTemplate>
        <div class="msg_tips">
          <ng-container
            *ngIf="
              getMessagesByType(
                data.errorMessages,
                'E',
                'qty_warning'
              ) as messages
            "
          >
            <div class="flex" *ngFor="let msg of messages">
              <i class="tip_item"></i>
              <p>{{ msg }}</p>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template #msgTemplate>
        <div class="msg_tips">
          <ng-container>
            <div class="flex" *ngFor="let msg of data.errorMessages">
              <i
                class="tip_item"
                [ngClass]="{
                  'bg-errorTips': msg.severity == 'E',
                  'bg-yellow': msg.severity == 'W'
                }"
              ></i>
              <p>{{ msg.message }}</p>
            </div>
            <div class="flex" *ngFor="let msg of getPromptMessages(data)">
              <i class="tip_item bg-yellow"></i>
              <p>{{ msg }}</p>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template #stockTemplate>
        <div class="price-info">
          {{
            data.stockQuantity === 0
              ? ("NO_STOCK" | translate)
              : data.quantity <= data.stockQuantity
              ? ("IN_STOCK" | translate)
              : ("LOW_STOCK" | translate)
          }}
        </div>
      </ng-template>

      <ng-template #infoTemplate>
        <div class="price-info">
          <div class="flex">
            <span class="info-title color-black font16-w500">
              {{ "EAN" | translate }}:</span
            >
            <span class="color-grey7C font16-w500">{{ data.ean || "--" }}</span>
          </div>
          <div class="flex">
            <span class="info-title color-black font16-w500"
              >{{ "CART_VOLUME" | translate }}:</span
            >
            <span class="color-grey font16-w500">
              {{
                data.shipmentDimension?.totalVolume
                  ? (data.shipmentDimension.totalVolume | number : "1.2-2") +
                    data.shipmentDimension?.unitOfVolume
                  : "--"
              }}
            </span>
          </div>
          <div class="flex">
            <span class="info-title color-black font16-w500"
              >{{ "CART_WEIGHT" | translate }}:</span
            >
            <span class="color-grey font16-w500">
              {{
                data.shipmentDimension?.totalWeight
                  ? (data.shipmentDimension.totalWeight | number : "1.2-2") +
                    data.shipmentDimension?.unitOfWeight
                  : "--"
              }}
            </span>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </tbody>
</nz-table>
